import type { StudentSearchQuery, StudentSearchFilters } from '../types';

export const profileEndpoints = {
  getStudentMe: '/api/students/me',
  getStudent: (id: number | 'current' = 'current') => `/students/${id}`,
  updateProfile: '/students/current',
  updateStudentPhoto: '/api/users/me/photo',
  reportStudent: (studentId: number) => `/students/${studentId}/report`,
  searchStudents: (query?: StudentSearchQuery) => {
    const params = new URLSearchParams();
    if (query?.search) params.append('search', query.search);
    if (query?.limit) params.append('limit', query.limit.toString());
    if (query?.ids) params.append('ids', query.ids.join(','));
    if (query?.class) params.append('class', query.class);
    if (query?.topic) params.append('topic', query.topic);
    if (query?.companySiret) params.append('companySiret', query.companySiret);
    return `/students/search${params.toString() ? `?${params.toString()}` : ''}`;
  },
  getAssistances: '/assistances',
  addStudentAssistance: (assistanceId: number) => `/api/users/me/assistances/${assistanceId}`,
  removeStudentAssistance: (assistanceId: number) => `/api/users/me/assistances/${assistanceId}`,
  getHobbies: '/hobbies',
  addStudentHobby: (hobbyId: number) => `/api/users/me/hobbies/${hobbyId}`,
  removeStudentHobby: (hobbyId: number) => `/api/users/me/hobbies/${hobbyId}`,
  suggestHobby: '/api/users/me/hobbies',
  getLanguages: '/languages',
  searchCompanies: (search?: string, limit?: number) => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (limit) params.append('limit', limit.toString());
    return `/companies${params.toString() ? `?${params.toString()}` : ''}`;
  },
  getTopics: '/topics',
  getAssociations: '/associations',
};
